import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';


export const initialValues = { isModalOpen: false, open: () => { }, close: () => { }, toggle: () => {} };
export const SortByModalContext = createContext(initialValues);

export const SortByModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const open = () => {
    setIsModalOpen(true);
  };

  const close = () => {
    setIsModalOpen(false);
  };
  const toggle = () => {
    setIsModalOpen(!isModalOpen);
  };
  return (
    <SortByModalContext.Provider value={{ isModalOpen, open, close, toggle }}>
      {children}
    </SortByModalContext.Provider>
  );
};
SortByModalProvider.propTypes = {
  children: PropTypes.any
};
export const useSortByModal = () => useContext(SortByModalContext);
